/*
* @Author: Johnny.liu
* @Date:   2021-03-08 13:48:41
* @Last Modified by:   Johnny.liu
* @Last Modified time: 2021-03-08 13:49:22
*/
import { param } from "jquery";
import { HTTP } from "../../lib/http"
import url from "../../lib/url";

export const APIService = {

    http: HTTP,

    /**
    * [getValuationRanking 获取估值表数据排序接口]
    * @param  {[type]} param [description]
    * @return {[type]}       [description]
    */
    async getValuationRanking(param) {
        return await this.http.postImmediately({
            type: 'post',
            url: '/citic/get_valuation_ranking/',
            data: param
        });
    },

    /**
    * [getProjectList 项目列表接口]
    */
    async getProjectList() {
        return await this.http.postImmediately({
            type: 'post',
            url: '/citic/get_project_list/',
        });
    },

    /**
     * [getProjectInfo 一页通项目详情接口]
    */
    async getProjectInfo(param) {
        return await this.http.postImmediately({
            type: 'post',
            url: '/citic/get_project_info/',
            data: param
        });
    },

    /**
     * [getOpenDayList 一页通开放日列表接口]
    */
    async getOpenDayList(param) {
        return await this.http.postImmediately({
            type: 'post',
            url: '/citic/get_open_day_list/',
            data: param
        });
    },

    /**
     * [performanceReportData 获取绩效归因查看接口]
    */
    async performanceReportData(param) {
        return await this.http.postImmediately({
            type: 'post',
            url: '/citic/performance_report_data/',
            data: param
        });
    },

    /**
    * [getValuationListData 估值列表查看接口]
    */
    async getValuationListData(param) {
        return await this.http.postImmediately({
            type: 'post',
            url: '/citic/get_valuation_list_data/',
            data: param
        });
    },

    /**
    * [getNetWorthTrend 获取基金净值走势图数据接口]
    */
    async getNetWorthTrend(param) {
        return await this.http.postImmediately({
            type: 'post',
            url: '/citic/get_net_worth_trend/',
            data: param
        });
    },

    /**
    * [getHistoryValData 获取基金净值走势图数据接口]
    */
    async getHistoryValData(param) {
        return await this.http.postImmediately({
            type: 'post',
            url: '/citic/get_history_val_data/',
            data: param
        });
    },
}


// WEBPACK FOOTER //
// app/services/appraisement/api.js